
import { X } from 'lucide-react';

type ConfirmAnnullaDialogProps = {
  onConferma: () => void;
  onAnnulla: () => void;
};

export const ConfirmAnnullaDialog = ({ onConferma, onAnnulla }: ConfirmAnnullaDialogProps) => {
  return (
    <div className="text-center">
      <div className="flex justify-center mb-3">
        <div className="w-11 h-11 rounded-full bg-red-50 flex items-center justify-center">
          <X className="w-5 h-5 text-red-500" />
        </div>
      </div>
      <h2 className="text-base font-semibold mb-1 text-center">Annullare le modifiche?</h2>
      <p className="text-xs text-gray-400 mb-4">Le modifiche non salvate andranno perse.</p>
      <div className="flex justify-center gap-3 mt-4">
        <button
          onClick={onAnnulla}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-gray-200 text-xs font-medium text-gray-500 hover:border-gray-400 hover:text-gray-700 transition-all"
        >
          Indietro
        </button>
        <button
          onClick={onConferma}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-red-500 text-xs font-medium text-white hover:bg-red-600 transition-all"
        >
          Annulla modifiche
        </button>
      </div>
    </div>
  );
};
